<template>
    <div class="page-up-button" :class="rootClasses" @click="onClick">
        <icon class="page-up-button--icon" size="large" symbol="page-up"/>
    </div>
</template>

<script>
    import icon from 'framework/global-components/base/icon/icon';
    import bemMixin from 'framework/mixins/bem/index';

    export default {
        components: {
            icon,
        },
        mixins: [
            bemMixin('page-up-button'),
        ],
        data() {
            return {
                timeout: false,
                windowHeight: window.innerHeight,
                isButtonVisible: false,
            };
        },
        computed: {
            rootClasses() {
                return [
                    this.bemAdd(this.isButtonVisible ? null : 'is-hidden'),
                ];
            },
        },
        methods: {
            onClick() {
                window.scroll({ top: 0, behavior: 'smooth' });
            },
            pageButtonFade() {
                if (this.timeout) {
                    window.cancelAnimationFrame(this.timeout);
                }
                this.timeout = window.requestAnimationFrame(() => {
                    this.isButtonVisible = window.scrollY >= this.windowHeight / 2;
                });
            },
        },
        mounted() {
            window.addEventListener('scroll', this.pageButtonFade);
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.pageButtonFade);
        },
    };
</script>
